export const TOGGLE_SIDEBAR_OPEN = 'app/Sidebar/TOGGLE_SIDEBAR_OPEN';
